// Bundles the lesson-builder page's overlay/popup visibility state --
// nothing beyond the useState calls themselves. See
// docs/BLUEPRINT-2026-10-03-lesson-builder-decomposition.md for why this
// is split from lesson-builder/page.tsx and what its boundary is.

import { useState } from 'react'

export const useLessonBuilderOverlays = () => {
  const [showAssignClassOverlay, setShowAssignClassOverlay] = useState(false)
  const [showLaunchOverlay, setShowLaunchOverlay] = useState(false)
  const [showStudentLoginsOverlay, setShowStudentLoginsOverlay] = useState(false)
  const [copyOverlayMode, setCopyOverlayMode] = useState<'copy' | 'reassign' | null>(null)
  const [showPrintDraftOverlay, setShowPrintDraftOverlay] = useState(false)
  const [showPrintAnswerKeyOverlay, setShowPrintAnswerKeyOverlay] = useState(false)
  const [showPrintWorksheetsOverlay, setShowPrintWorksheetsOverlay] = useState(false)
  const [showReadyPopup, setShowReadyPopup] = useState(false)

  return {
    showAssignClassOverlay, setShowAssignClassOverlay,
    showLaunchOverlay, setShowLaunchOverlay,
    showStudentLoginsOverlay, setShowStudentLoginsOverlay,
    copyOverlayMode, setCopyOverlayMode,
    showPrintDraftOverlay, setShowPrintDraftOverlay,
    showPrintAnswerKeyOverlay, setShowPrintAnswerKeyOverlay,
    showPrintWorksheetsOverlay, setShowPrintWorksheetsOverlay,
    showReadyPopup, setShowReadyPopup,
  }
}

export type LessonBuilderOverlaysState = ReturnType<typeof useLessonBuilderOverlays>
